"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIconForClass = getIconForClass;
exports.iconForClassMap = void 0;
exports.presentStuff = presentStuff;
var _rdflib = require("rdflib");
var _solidUi = require("solid-ui");
var _solidLogic = require("solid-logic");
const {
  iconForClass
} = _solidUi.widgets;
const {
  typeIndex
} = _solidLogic.solidLogicSingleton;
const {
  getScopedAppInstances
} = typeIndex;
const iconForClassMap = exports.iconForClassMap = {}; // @@ move to buttons in solid-ui
for (const k in iconForClass) {
  const pref = k.split(':')[0];
  const id = k.split(':')[1];
  const theClass = _solidUi.ns[pref](id);
  iconForClassMap[theClass.uri] = _rdflib.uri.join(iconForClass[k], _solidUi.icons.iconBase);
}
function getIconForClass(klass) {
  const icon0 = iconForClassMap[klass.uri];
  return icon0 || _solidUi.icons.iconBase + 'noun_10636.svg'; //  fall back to black disk
}
async function presentStuff(subject) {
  const scopedItems = await getScopedAppInstances(null, subject);
  // console.log('scopedItems', scopedItems)

  const stuff = scopedItems.map(item => {
    // work with old or new solid-logic
    const icon = getIconForClass(item.type || _solidUi.ns.rdf('Resource'));
    const href = item.instance.uri;
    const name = _solidUi.utils.label(item.instance);
    const instance = item.instance;
    // console.log(`   href=${href} name=${name} icon=${icon}`)
    return {
      href,
      name,
      icon,
      instance
    };
  });
  return {
    stuff
  };
}